import {dispatch} from '../store'

import {SET_PLUGIN_SETTINGS} from '../action_types'

export default (settings) => {
  dispatch({type: SET_PLUGIN_SETTINGS, settings})
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/plugin_settings.js
 **/